export class CreateChildLinkParams {
  expiresAt: string | null

  constructor({ expiresAt }: { expiresAt: string | null }) {
    this.expiresAt = expiresAt
  }
}
